import mapValues from 'lodash/mapValues';

// @ts-strict-ignore
import {SupportInfo as ApiSupportInfo} from 'app_api/billing/types';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {apiClient} from 'common/util/api-client';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

function buildEndpoint(): string {
  return appApiUrl(`billing/user_support_info`);
}

function processResponse(apiSupportInfo: ApiSupportInfo | null): SupportInfo {
  if (!apiSupportInfo) {
    return null;
  }

  return {
    billingAccount: {
      id: apiSupportInfo.billing_account.id,
      recurringServiceArr: apiSupportInfo.billing_account.recurring_service_arr,
      arr: apiSupportInfo.billing_account.arr,
    },
    userAgeDays: apiSupportInfo.user_age_days,
    supportChatEnabled: apiSupportInfo.support_chat_enabled,
    servicePlanIds: apiSupportInfo.service_plan_ids,
  };
}

class OldSupportInfoClient extends BaseClient<SupportInfo> {
  buildEndpoint() {
    return buildEndpoint();
  }

  processResponse(response) {
    return processResponse(response.results as ApiSupportInfo);
  }
}

export const oldSupportInfoClient = new OldSupportInfoClient();

export type BillingAccount = {
  id: number;
  recurringServiceArr: number;
  arr: number;
};

export type SupportInfo = {
  billingAccount: BillingAccount;
  userAgeDays: number;
  supportChatEnabled: boolean;
  servicePlanIds: number[];
};

// support info endpoint doesn't take an id. `id` is needed by ApiSingleValueResource
export const SUPPORT_INFO_SENTINEL_ID = `sentinel_id`;

export const supportInfoClient: ApiResourceClient<SupportInfo> = {
  index() {
    throw new Error(`supportInfoClient does not support index queries`);
  },

  get(id: string) {
    if (id !== SUPPORT_INFO_SENTINEL_ID) {
      throw new Error(`supportInfoClient: unexpected id ${SUPPORT_INFO_SENTINEL_ID}`);
    }
    const fetches = apiClient.hydratedGet<ApiSupportInfo>(buildEndpoint());
    return mapValues(fetches, (fetch) => fetch.then((apiSupportInfo) => processResponse(apiSupportInfo)));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
